/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { campaignStatusReview } from '../../axios/campaignStatusReview'
import type {
	CampaignStatusReviewError,
	CampaignStatusReviewPathParams,
	CampaignStatusReviewRequest,
	CampaignStatusReviewResponse,
} from '../../types/CampaignStatusReview'

export const campaignStatusReviewMutationKey = () => [{ url: '/campaigns/:campaign/submit-for-review' }] as const

export type CampaignStatusReviewMutationKey = ReturnType<typeof campaignStatusReviewMutationKey>

export type CampaignStatusReviewVariables = {
	campaign: CampaignStatusReviewPathParams['campaign']
	data: CampaignStatusReviewRequest
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CampaignStatusController.php CampaignStatusController::review */
export function useCampaignStatusReview<TContext = unknown>(
	options?: UseMutationOptions<
		CampaignStatusReviewResponse,
		AxiosError<CampaignStatusReviewError>,
		CampaignStatusReviewVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: campaignStatusReviewMutationKey(),
		mutationFn: ({ campaign, data }: CampaignStatusReviewVariables) =>
			campaignStatusReview(campaign, data, config).then(res => res.data),
		...options,
	})
}
